/** Мелкие элементы постов: статус, тип источника, подпись к фото, вкладки. */
import type { ReactNode } from "react";
import { SOURCE_LABEL, STATUS_LABEL, type PostImage, type PostSource, type PostStatus } from "@impuls/shared";
import { domainOf, humanDateTime } from "../lib/format";

export function StatusChip({ status, at }: { status: PostStatus; at?: number | null }) {
  const cls =
    status === "scheduled" ? "chip--wine" : status === "published" ? "chip--ok" : status === "failed" ? "chip--danger" : "chip--outline";
  const text = status === "scheduled" && at ? `Запланирован на ${humanDateTime(at * 1000)}` : STATUS_LABEL[status];
  return <span className={`chip ${cls}`}>{text}</span>;
}

/** Тип автопоста: Новость — красный, Факт — бордовый, Миф — янтарный, По запросу — тёмный (бриф). Международка — своей меткой рядом. */
export function SourceTag({ source, international = false }: { source: PostSource; international?: boolean }) {
  if (source === "author") return null;
  const cls = source === "news" ? "chip--red" : source === "fact" ? "chip--wine" : source === "myth" ? "chip--warn" : "chip--ink";
  return (
    <>
      <span className={`chip ${cls}`}>{SOURCE_LABEL[source]}</span>
      {international && <span className="chip chip--outline">Международка</span>}
    </>
  );
}

/** «Фото: сайт» — у фото со страницы источника (старые автопосты), ссылкой на эту страницу. У своих и нарисованных — ничего. */
export function PhotoCredit({ image, className = "" }: { image: Pick<PostImage, "origin" | "source_url">; className?: string }) {
  if (image.origin !== "source" || !image.source_url) return null;
  const site = domainOf(image.source_url);
  return (
    <a
      className={`photo-credit ${className}`}
      href={image.source_url}
      target="_blank"
      rel="noreferrer"
      title={`Фото со страницы ${site}`}
      draggable={false}
    >
      Фото: {site}
    </a>
  );
}

export function Tabs<T extends string>({
  tabs,
  value,
  onChange,
  label,
}: {
  tabs: { value: T; label: ReactNode; count?: number }[];
  value: T;
  onChange: (v: T) => void;
  label: string;
}) {
  return (
    <div className="tabs" role="tablist" aria-label={label}>
      {tabs.map((t) => (
        <button
          key={t.value}
          role="tab"
          aria-selected={value === t.value}
          className={`tabs__tab ${value === t.value ? "is-active" : ""}`}
          onClick={() => onChange(t.value)}
        >
          {t.label}
          {t.count !== undefined && t.count > 0 && <span className="tabs__count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
